<div class="pod-section" [formGroup]="form" *ngIf="isVisible">

  <h2 class="pod-section__title">{{ sectionLabel }}</h2>

  <div class="pod-grid">

    <div class="pod-field pod-field--full">
      <app-info-banner
        *ngIf="bannerMessage"
        [message]="bannerMessage"
        [background]="ERROR_BANNER.BG"
        [iconColor]="ERROR_BANNER.ICON_COLOR"
      ></app-info-banner>

      <ng-container *ngIf="isLinkMode; else filesCard">
        <div class="pod-link-card">
          <div class="pod-link-card__icon">
            <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg" style="padding: 2px;">
              <circle cx="53" cy="53" r="52.5" stroke="#4589FF" />
              <path d="M76.5 33.5L66 24H36C34.1667 24 30.5 25.1 30.5 29.5C30.5 33.9 30.5 63.6667 30.5 78C30.6667 79.8 32 83.5 36 83.5C40 83.5 61.3333 83.5 71.5 83.5C73.1667 83.3333 76.5 82 76.5 78C76.5 74 76.5 46.6667 76.5 33.5ZM66 24C65.5 25.6667 65 29.5 67 31.5C69 33.5 74.1667 33.6667 76.5 33.5" stroke="#4589FF" />
              <g clip-path="url(#clip0_1119_54341)">
                <path d="M61 44H49C47.9 44 47 44.9 47 46V58C47 59.1 47.9 60 49 60H61C62.1 60 63 59.1 63 58V46C63 44.9 62.1 44 61 44ZM44 48C43.45 48 43 48.45 43 49V62C43 63.1 43.9 64 45 64H58C58.55 64 59 63.55 59 63C59 62.45 58.55 62 58 62H46C45.45 62 45 61.55 45 61V49C45 48.45 44.55 48 44 48Z" fill="#4589FF" />
              </g>
              <defs>
                <clipPath id="clip0_1119_54341">
                  <rect width="24" height="24" fill="white" transform="translate(41 42)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <button type="button" class="pod-link-card__btn" (click)="goToLink()">
            Go to files
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M6 4h6v6M12 4L5 11M4 8v4h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </ng-container>

      <ng-template #filesCard>
        <app-files-card
          [form]="form"
          [controlName]="CONTROL_NAME"
          [acceptExtensions]="acceptExtensions"
          [acceptMimes]="acceptMimes"
          [maxSizeBytes]="maxSizeBytes"
          [maxFiles]="maxFiles"
          [multiple]="true"
          [required]="true"
          [submitted]="submitted"
          [readOnly]="viewMode"
          [showDownload]="viewMode"
          [showRequiredLabel]="false"
          [labels]="cardLabels"
          [messages]="cardMessages"
          (validationError)="onCardValidationError($event)"
          (filesChanged)="onFilesChanged($event)"
        ></app-files-card>
      </ng-template>
    </div>

  </div>
</div>
